export class AdCreationError extends Error {
    constructor(message: string) {
        super(message);
    }
}
export class AdCreationError extends Error {
    constructor(message: string) {
        super(message);
    }
}
